// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.row-info-panel {
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.info-section-title {
  display: block;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 13px;
  text-transform: lowercase;
  padding-bottom: 8px;
  border-bottom: 2px solid #8c8f93;
  margin-bottom: 10px;
}

.info-panel-roles {
  padding: 16px 20px 20px 16px;
}
.info-panel-roles .info-section-title {
  margin-bottom: 14px;
}

.role-groups-row {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.role-group {
  display: flex;
  flex-direction: column;
  min-width: 120px;
}

.role-group-label {
  font-size: 13px;
  color: #707070;
  text-transform: lowercase;
  margin-bottom: 3px;
}

.role-group-names {
  font-size: 13px;
  font-family: "Gotham", Arial, sans-serif;
  line-height: 1.5;
}

.info-panel-comments {
  padding: 4px 20px 16px 16px;
}

.info-comments-loading {
  display: flex;
  align-items: center;
  padding: 8px 0;
}

.info-comments-error {
  color: #97002e;
  font-size: 13px;
  margin: 4px 0;
}

.info-comments-tabs {
  margin-top: -6px;
}
.info-comments-tabs .mat-mdc-tab-labels {
  border-bottom: 1px solid #e3e3e3;
}
.info-comments-tabs .mat-mdc-tab .mdc-tab__text-label {
  font-size: 12px;
  font-family: "Gotham", Arial, sans-serif;
  color: #707070;
  text-transform: lowercase;
}
.info-comments-tabs .mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
}
.info-comments-tabs .mat-mdc-tab-body-wrapper {
  padding-top: 0;
}

.info-comments-tab-body {
  padding: 10px 0 4px;
  max-height: 260px;
  overflow-y: auto;
}

.info-comment {
  padding-bottom: 0;
  margin-bottom: 18px;
}
.info-comment:last-child {
  margin-bottom: 0;
}

.info-comment-header {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  margin-bottom: 4px;
  font-size: 13px;
  line-height: 1.5;
}

.info-comment-author {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
}

.info-comment-meta {
  color: #5b9bd5;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 12px;
}

.info-comment-content {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
}

.info-no-comments {
  font-size: 13px;
  color: #8c8f93;
  margin: 4px 0;
  font-style: italic;
}

.info-replies-toggle {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-top: 4px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  color: #5b9bd5;
  font-family: "Gotham", Arial, sans-serif;
}
.info-replies-toggle mat-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  line-height: 16px;
}
.info-replies-toggle:hover {
  color: #0066b2;
}

.info-replies-container {
  margin-top: 10px;
  padding-left: 14px;
  border-left: 2px solid #e3e3e3;
}
.info-replies-container .info-reply {
  margin-bottom: 12px;
}
.info-replies-container .info-reply:last-child {
  margin-bottom: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
